import { ViewRef, ComponentRef } from '@angular/core';

export class ModalDialogContentRef<T> {
    constructor(public nodes: [HTMLElement[]], public viewRef?: ViewRef, public componentRef?: ComponentRef<T>) {}
}

export function isString(value: unknown): value is string {
    return typeof value === 'string';
}

export function isDefined(value: unknown): boolean {
    return value != null;
}
